import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import './IndustryReviews.css';
import { Button, ReviewsCard, Section, Title } from '../../importCL';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { ButtonWrapper } from '../LinkWrapper/LinkWrapper';

export interface IIndustryReviewsProps extends MappedComponentProperties {
  headlineText?: string;
  backgroundColor?: string;
  cards?: {
    headlineText?: string;
    imagePath?: string;
    imageAltText?: string;
    link?: string;
    linkText?: string;
  }[];
}

export const IndustryReviewsEditConfig = {
  emptyLabel: 'Industry Reviews',
  isEmpty: (props: PropsWithChildren<IIndustryReviewsProps>) => {
    return !props || !props.headlineText;
  },
};

const IndustryReviews = (
  props: PropsWithChildren<IIndustryReviewsProps>,
): JSX.Element => {
  return props.cards?.length === 1 ? (
    <Section
      className='IndustryReviews'
      containerClass='IndustryReviews__sectionContainer justify-center flex'
      bgColor={props.backgroundColor === 'lightGrey' ? 'light-grey' : 'white'}
    >
      <Title
        className='IndustryReviews__title text-grey-tundora'
        verticalBar
        align='left'
        tag='h2'
      >
        {props.headlineText ? transformHTMLParserLinks(props.headlineText) : ''}
      </Title>
      <ReviewsCard
        cardVariant='news'
        className={`IndustryReviews__card--1 ${
          props.backgroundColor === 'white' ? 'IndustryReviews--shadow' : ''
        } '!px-0'`}
        headLineSettings={{
          textClass: 'text-lg font-bold mb-0',
        }}
        topElement={
          <div className={`flex`}>
            <img
              className='mb-6 IndustryReviews__image'
              src={props.cards[0].imagePath as string}
              alt={props.cards[0].imageAltText ?? 'image'}
            />
          </div>
        }
        reviewContent={{
          headLineText: transformHTMLParserLinks(props.cards[0].headlineText ?? ''),
        }}
      >
        <div className='IndustryReviews__divider' />
        {props.cards[0].linkText && props.cards[0].link && (
          <Button
            className='!p-0 underline !text-base !mb-0'
            variant='link'
            href={props.cards[0].link}
          >
            {transformHTMLParserLinks(props.cards[0].linkText)}
          </Button>
        )}
      </ReviewsCard>
    </Section>
  ) : (
    <Section
      className='IndustryReviews'
      containerClass='IndustryReviews__sectionContainer'
      bgColor={props.backgroundColor === 'lightGrey' ? 'light-grey' : 'white'}
      horizontalTitle
      title={props.headlineText ? transformHTMLParserLinks(props.headlineText) : ''}
      titleClass='text-grey-tundora'
    >
      <div className={`IndustryReviews__cards flex justify-start flex-wrap`}>
        {props.cards &&
          props.cards.slice(0, 6).map((card, index) => (
            <ReviewsCard
              key={index}
              cardVariant='news'
              className={`IndustryReviews__card--${
                props.cards.length < 6 ? props.cards.length : '6'
              } ${
                props.backgroundColor === 'white'
                  ? 'IndustryReviews--shadow'
                  : ''
              } '!px-0'`}
              headLineSettings={{
                textClass: 'text-lg font-bold mb-0',
              }}
              topElement={
                <div className={`flex`}>
                  <img
                    className='mb-4 IndustryReviews__image'
                    src={card.imagePath as string}
                    alt={card.imageAltText ?? 'image'}
                  />
                </div>
              }
              reviewContent={{
                headLineText: transformHTMLParserLinks(card.headlineText ?? ''),
              }}
            >
              {(props.cards.length === 1 ||
                props.cards.length === 2 ||
                props.cards.length === 4) && (
                <div className='IndustryReviews__divider' />
              )}
              {card.linkText && card.link && (
                <ButtonWrapper
                  className='!p-0 underline !text-base !mb-0'
                  variant='link'
                  href={card.link}
                >
                  {transformHTMLParserLinks(card.linkText)}
                </ButtonWrapper>
              )}
            </ReviewsCard>
          ))}
      </div>
    </Section>
  );
};

export default IndustryReviews;
